module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki07_sp-5fa0ab19cc26e075c273ea115eb65f45.jpg";